import OrderService from "../../../services/order.service";
import GruposService from "../api/grupos.api";
import { ORDER_ACTION, ORDER_STATE } from "../../../config/constants";
import { pedidosDeGrupo } from "./ticketGrupoN2";

/**
 * Lo que hace el "Imprimir" del punteo de Nave 2, para los botones de etiqueta de los
 * listados: asignar el preparador antes de imprimir y pasar a "en preparación" después.
 * Mismas llamadas que InfoOrder (y que OrderN2Grupo para los grupos).
 */

// Mismo POST n2/asignar que el punteo: un campo por llamada, como hace InfoOrder
const asignarN2 = (numero, tipo, year, { preparador = null, estado = null }) =>
    OrderService.assignToOrder(numero, null, preparador, ORDER_ACTION.VENTAS, estado, true, undefined, year, null, tipo);

/**
 * Asigna el preparador a un pedido suelto del listado (num, type)
 */
export const asignarPreparadorPedido = (pedido, preparador, year) =>
    asignarN2(pedido.num, pedido.type, year, { preparador });

/**
 * Pasa un pedido suelto del listado a "en preparación"
 */
export const pasarPedidoAEnPreparacion = (pedido, year) =>
    asignarN2(pedido.num, pedido.type, year, { estado: ORDER_STATE.EN_PREPARACION });

/**
 * Asigna el preparador a todos los pedidos de un grupo y lo guarda en el grupo
 */
export const asignarPreparadorGrupo = async (grupo, preparador, year) => {
    await Promise.all(
        pedidosDeGrupo(grupo).map(({ numero, tipo }) => asignarN2(numero, tipo, year, { preparador }))
    );
    await GruposService.updatePreparador(grupo.id, preparador);
};

/**
 * Pasa los pedidos de un grupo a "en preparación" y el grupo a EN_PROCESO
 */
export const pasarGrupoAEnPreparacion = async (grupo, year) => {
    await Promise.all(
        pedidosDeGrupo(grupo).map(({ numero, tipo }) =>
            asignarN2(numero, tipo, year, { estado: ORDER_STATE.EN_PREPARACION }))
    );
    await GruposService.updateEstado(grupo.id, year, 'EN_PROCESO');
};
